<template>
  <a class="c-propad" :href="ad.url" target="_blank">
    <aside class="c-propad--body">
      <div>
        <h3>{{ad.title}}</h3>
        <p>{{ad.body}}</p>
      </div>
      <figure>
        <img :src="ad.image.url">
      </figure>
    </aside>
  </a>
</template>

<script>
export default {
  name: 'CommonPropertyAd',
  props: ['adlist'],
  components: {
  },
  data() {
    return {};
  },
  computed: {
    ad() {
      return this.adlist[Math.floor(Math.random() * (this.adlist.length))];
    },
  },
};

</script>

<style scoped lang="scss">
.c-propad {
  display: block;
  margin: 20px 0;
  figure {
    width: 146px;
    height: 110px;
    background-color: #CCC;
    overflow: hidden;
    img {
      width: 143px;
      height: 110px;
      object-fit: contain;
    }
  }
  &--body {
    display:flex;
    flex-direction: row-reverse;
    border: 1px solid #EFEFEF;
    div{
      width: calc(712px - 146px);
      height: 110px;
      padding: 20px 10px;
      border-left: 1px solid #EFEFEF;
      & > h3 {
        font-size:18px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
      & > p {
        font-size: 14px;
        line-height: 1.7em;
        margin-top: 15px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }

  }

  &--sub {
    display: flex;
    margin: 10px;
    justify-content: space-between;
    align-items: center;
  }

}
@media screen and (max-width: 767px) {
  .c-propad {
    background-color: #FFF;
    &--body {
      padding: 10px;
      div{
        width: calc(346px - 146px);
        border-left: 0;
        padding:10px;
        & > h3 {
          margin: 0;
          font-size: 14px;
          -webkit-line-clamp: 2;
          line-height:1.5em
        }
        & > p {
            margin-top: 10px;
            font-size: 12px;
        }
      }
    }
  }
}

</style>
